import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65c0ec32"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=65c0ec32&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c0ec32')) {
      api.createRecord('65c0ec32', component.options)
    } else {
      api.reload('65c0ec32', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=65c0ec32", function () {
      api.rerender('65c0ec32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/userAgreement/list/index.vue"
export default component.exports